'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'far';
var iconName = 'user-group';
var width = 576;
var height = 512;
var aliases = [128101,"user-friends"];
var unicode = 'f500';
var svgPathData = 'M208 208a80 80 0 1 0 0-160 80 80 0 1 0 0 160zM208 0a128 128 0 1 1 0 256 128 128 0 1 1 0-256zM176 352c-70.7 0-128 57.3-128 128l0 8c0 13.3-10.7 24-24 24S0 501.3 0 488l0-8c0-97.2 78.8-176 176-176l64 0c97.2 0 176 78.8 176 176l0 8c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-8c0-70.7-57.3-128-128-128l-64 0zM343.3 240.6c10.2-12.3 18.8-26 25.4-40.7 9.2 5.2 19.9 8.2 31.3 8.2 35.3 0 64-28.7 64-64s-28.7-64-64-64c-7.6 0-14.9 1.3-21.6 3.7-4.1-15.8-10.3-30.7-18.3-44.4 12.4-4.7 25.9-7.3 39.9-7.3 61.9 0 112 50.1 112 112S461.9 256 400 256c-20.7 0-40.1-5.6-56.7-15.4zm92.6 130.7c-10.5-18.9-23.7-36.2-39.1-51.3l11.2 0c92.8 0 168 75.2 168 168 0 13.3-10.7 24-24 24s-24-10.7-24-24c0-56.7-39.3-104.2-92.1-116.7z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faUserGroup = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;